import React, { useState, useEffect } from 'react'
import { useQueryParams } from 'raviger'

import { colors } from 'Constants'

import { getReport } from '../helpers'
import request from 'Request'

import { Flex } from 'lese'
import ScaleLoader from 'react-spinners/ScaleLoader'
import ReportTitle from '../components/ReportTitle'
import ReportHeader from '../components/ReportHeader'
import DoctorReport from './components/DoctorActivityReport'

import { useStore } from 'laco-react'
import { ReportSortingStore } from 'Store'

export default () => {
  const reportSortingState = useStore(ReportSortingStore)
  const [
    { startDate, endDate, showArchivedOffices },
    setQuery
  ] = useQueryParams()
  const [reportSets, setReportSets] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(async () => {
    const newReportSet = await request('/info/app-codes/list').then(res =>
      res.data.map(appCode => ({ appCode, reports: [] }))
    )
    const requests = []
    for (const reportSet of newReportSet) {
      requests.push(
        getReport('/reports/activity/get', {
          appCode: reportSet.appCode,
          startDate,
          endDate,
          showArchivedOffices
        }).then(reports => (reportSet.reports = reports))
      )
    }
    await Promise.all(requests)
    setReportSets(newReportSet)
    setLoading(false)
  }, [])

  return (
    <>
      <ReportTitle
        title={`Cluster Activity Report`}
        csvUrl="/reports/activity/csv"
        csvPayload={reportSortingState}
      />
      {loading && (
        <Flex xAlign yAlign height="70vh">
          <ScaleLoader color={colors.secondary} loading={loading} />
        </Flex>
      )}
      {reportSets.map(reportSet => (
        <>
          <ReportHeader
            header="App Code"
            title={reportSet.appCode}
            cardValues={[]}
          ></ReportHeader>
          {reportSet.reports.map(report => (
            <>
              <ReportHeader
                header="Office"
                title={report.title}
                cardValues={[
                  ['Total Reported', 'Patients', report.totalPatients],
                  ['Total Reported', 'Journeys', report.totalJourneys],
                  ['Total Unstarted', 'Journeys', report.journeysNotStarted],
                  ['Total Completed', 'Forms', report.formsCompleted],
                  ['Total Reported', 'Alerts', report.flags]
                ]}
              />
              {Object.values(report.doctors).length === 0 && (
                <div
                  style={{
                    textAlign: 'center',
                    padding: '16px 0',
                    margin: '16px 0',
                    borderBottom: `1px solid ${colors.borderColor}`
                  }}
                >
                  There are no items in this office
                </div>
              )}
              {Object.values(report.doctors).map(doctor => (
                <DoctorReport doctor={doctor} />
              ))}
            </>
          ))}
        </>
      ))}
    </>
  )
}
